import { useSelector } from "react-redux";
import store from "../stores/store";
import { setLayerTimeDimension } from "../components/map/mapUtils";

const initialState = {
  layers: {},
  availableDimensions: [],
  status: null,
  interval: 2000,
  colors: [
    "rgba(230, 25, 75, 0.8)",
    "rgba(60, 180, 75, 0.8)",
    "rgba(255, 225, 25, 0.8)",
    "rgba(0, 130, 200, 0.8)",
    "rgba(245, 130, 48, 0.8)",
    "rgba(70, 240, 240, 0.8)",
    "rgba(240, 50, 230, 0.8)",
    "rgba(250, 190, 212, 0.8)",
    "rgba(0, 128, 128, 0.8)",
    "rgba(220, 190, 255, 0.8)",
    "rgba(170, 110, 40, 0.8)",
    "rgba(255, 250, 200, 0.8)",
    "rgba(128, 0, 0, 0.8)",
    "rgba(170, 255, 195, 0.8)",
    "rgba(0, 0, 128, 0.8)",
    "rgba(128, 128, 128, 0.8)",
    "rgba(255, 255, 255, 0.8)",
    "rgba(0, 0, 0, 0.8)",
  ],
};

export default function timeDimensionReducer(state = initialState, action) {
  switch (action.type) {
    case "loadconfiguration":
      {
        return {
          layers: {},
          availableDimensions: [],
          status: null,
          interval: 2000,
          colors: [
            "rgba(230, 25, 75, 0.8)",
            "rgba(60, 180, 75, 0.8)",
            "rgba(255, 225, 25, 0.8)",
            "rgba(0, 130, 200, 0.8)",
            "rgba(245, 130, 48, 0.8)",
            "rgba(70, 240, 240, 0.8)",
            "rgba(240, 50, 230, 0.8)",
            "rgba(250, 190, 212, 0.8)",
            "rgba(0, 128, 128, 0.8)",
            "rgba(220, 190, 255, 0.8)",
            "rgba(170, 110, 40, 0.8)",
            "rgba(255, 250, 200, 0.8)",
            "rgba(128, 0, 0, 0.8)",
            "rgba(170, 255, 195, 0.8)",
            "rgba(0, 0, 128, 0.8)",
            "rgba(128, 128, 128, 0.8)",
            "rgba(255, 255, 255, 0.8)",
            "rgba(0, 0, 0, 0.8)",
          ],
        };
      }
      break;

    case "loadconfiguration":
      {
        let newState = { ...state };

        newState.layers = {};

        newState.status = null;

        newState.availableDimensions = [];

        return newState;
      }
      break;

    case "layer/loaded":
      {
        let newState = { ...state };

        if (action.payload.layer.dimensions) {
          if (!newState.layers[action.payload.id]) {
            newState.layers[action.payload.id] = {};
            newState.layers[action.payload.id]["dimensions"] = [
              ...action.payload.layer.dimensions,
            ];
            newState.layers[action.payload.id]["visible"] = true;
          }
        }

        let availableDimensions = [];

        Object.keys(newState.layers).forEach((layerId) => {
          if (newState.layers[layerId]["visible"]) {
            availableDimensions = [
              ...availableDimensions,
              ...newState.layers[layerId].dimensions,
            ];
          }
        });

        newState.availableDimensions = availableDimensions
          .filter((value, index, array) => array.indexOf(value) === index)
          .sort(function (a, b) {
            return new Date(b.date) - new Date(a.date);
          });

        return newState;
      }
      break;

    case "timeDimension/gotonext":
      {
        let newState = { ...state };

        newState.currentDimension =
          newState.availableDimensions[
            newState.availableDimensions.indexOf(newState.currentDimension) + 1
          ] && newState.currentDimension
            ? newState.availableDimensions[
                newState.availableDimensions.indexOf(
                  newState.currentDimension
                ) + 1
              ]
            : newState.availableDimensions[0];

        Object.keys(newState.layers).forEach((layerId) => {
          if (
            newState.layers[layerId].dimensions.indexOf(
              newState.currentDimension
            ) >= 0
          ) {
            setLayerTimeDimension({ id: layerId }, newState.currentDimension);
          }
        });

        return newState;
      }
      break;

    case "timeDimension/gotoprevious":
      {
        let newState = { ...state };

        newState.currentDimension =
          newState.availableDimensions[
            newState.availableDimensions.indexOf(newState.currentDimension) - 1
          ] && newState.currentDimension
            ? newState.availableDimensions[
                newState.availableDimensions.indexOf(
                  newState.currentDimension
                ) - 1
              ]
            : newState.availableDimensions[0];

        Object.keys(newState.layers).forEach((layerId) => {
          if (
            newState.layers[layerId].dimensions.indexOf(
              newState.currentDimension
            ) >= 0
          ) {
            setLayerTimeDimension({ id: layerId }, newState.currentDimension);
          }
        });

        return newState;
      }
      break;

    case "timeDimension/goto":
      {
        let newState = { ...state };

        newState.currentDimension = action.payload;

        Object.keys(newState.layers).forEach((layerId) => {
          if (
            newState.layers[layerId].dimensions.indexOf(action.payload) >= 0
          ) {
            setLayerTimeDimension({ id: layerId }, action.payload);
          }
        });

        return newState;
      }
      break;

    case "timeDimension/toggleplay":
      {
        let newState = { ...state };

        if (window["timeDimension"]) {
          clearInterval(window["timeDimension"]);
          window["timeDimension"] = null;
        } else {
          window["timeDimension"] = setInterval(() => {
            store.dispatch({ type: "timeDimension/gotonext" });
          }, newState.interval);
        }
        return newState;
      }
      break;

    case "timeDimension/interval":
      {
        let newState = { ...state };
        newState.interval = action.payload;
        if (newState.interval < 500) {
          newState.interval = 500;
        }
        clearInterval(window["timeDimension"]);
        window["timeDimension"] = setInterval(() => {
          store.dispatch({ type: "timeDimension/gotonext" });
        }, newState.interval);
        return newState;
      }
      break;

    case "timeDimension/layer/togglevisible":
      let newState = { ...state };

      if (newState.layers[action.payload]["visible"]) {
        newState.layers[action.payload]["visible"] = false;
      } else {
        newState.layers[action.payload]["visible"] = true;
      }

      let availableDimensions = [];

      Object.keys(newState.layers).forEach((layerId) => {
        if (newState.layers[layerId]["visible"]) {
          availableDimensions = [
            ...availableDimensions,
            ...newState.layers[layerId].dimensions,
          ];
        }
      });

      newState.availableDimensions = availableDimensions
        .filter((value, index, array) => array.indexOf(value) === index)
        .sort(function (a, b) {
          return new Date(b.date) - new Date(a.date);
        });

      return newState;

      break;

    case "layer/deleteById":
      {
        let newState = { ...state };

        delete newState.layers[action.payload];

        let availableDimensions = [];

        Object.keys(newState.layers).forEach((layerId) => {
          if (newState.layers[layerId]["visible"]) {
            availableDimensions = [
              ...availableDimensions,
              ...newState.layers[layerId].dimensions,
            ];
          }
        });

        newState.availableDimensions = availableDimensions
          .filter((value, index, array) => array.indexOf(value) === index)
          .sort(function (a, b) {
            return new Date(b.date) - new Date(a.date);
          });

        return newState;
      }
      break;

    default:
      return state;
  }
}
